import React from 'react'
import { Link } from 'react-router-dom'
import { getTenantBrand } from '../../config/tenant'

const ProductNameHeader = () => {
  const { logoAlt } = getTenantBrand()
  return (
    <div className="text-bold">
      <Link to="/contactAddress">
        <img src="2-C-2.png"
          alt={logoAlt}
          width="250"
          height="32.5"
        />
      </Link>
    </div>
  )
}

export default ProductNameHeader
